// extracted by mini-css-extract-plugin
module.exports = {"disable-scroll":"uploadhistory_disable-scroll__2E7Cx"};